import { render } from "./list.vue?vue&type=template&id=21f23642&scoped=true"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"

import "./list.vue?vue&type=style&index=0&id=21f23642&lang=scss&scoped=true"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21f23642"],['__file',"src/views/widget/list.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "21f23642"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('21f23642', __exports__)) {
    console.log('reload')
    api.reload('21f23642', __exports__)
  }
  
  module.hot.accept("./list.vue?vue&type=template&id=21f23642&scoped=true", () => {
    console.log('re-render')
    api.rerender('21f23642', render)
  })

}


export default __exports__